import {
  CONTEXT_MENU_GROUP_NAME,
  CONTEXT_MENU_VISIBILITY_GROUP_NAME,
} from 'src/js/modules/blocks/constants/common';

const BLOCK_GROUP_NAMES = [CONTEXT_MENU_GROUP_NAME, CONTEXT_MENU_VISIBILITY_GROUP_NAME];

const filteredMatchedGroups = (groups) =>
  groups.filter((group) => !BLOCK_GROUP_NAMES.includes(group.name));

export default filteredMatchedGroups;
